module.exports = __webpack_public_path__ + "img/inwards-agility.4f0af1d1.png";